export default __webpack_public_path__ + "static/media/039-snokel and mask.64dc81af.svg";